import Swiper from "swiper";
import { A11y, Autoplay, EffectFade } from "swiper/modules";

export default {
  init: () => {
    document.querySelectorAll(".page-header .header-media-slider").forEach((el) => {
      const container = el.querySelector(".swiper");

      const opts = {
        modules: [A11y, Autoplay, EffectFade],
        autoplay: {
          delay: 4000,
        },
        effect: "fade",
        fadeEffect: {
          crossFade: true,
        },
        loop: true,
        speed: 1000,
      };

      new Swiper(container, opts);
    });
  },
};
